////////////////////////////////////////////////////////////////////////////////
// In View
////////////////////////////////////////////////////////////////////////////////

/**
 * Event listener that handles various and combined events
 * @author Mark Notton <mark@marknotton.uk>
 * @link https://github.com/marknotton/custom-properties
 * @module Utilities
 * @external "jQuery.fn"
 * @license Apache-2.0
 */

let InViewInstance = null

class InView extends Utilities {

	constructor() {
 		super()

    if (!InViewInstance) {
      this.extend('inview', 'check')
      InViewInstance = this;
    }

    return InViewInstance
 	}

	init(...settings) {

    console.log('Inview Init')

		let callback = null
		let element = null

		this.manage(settings, {
			boolean  : (setting) => { console.log('boolean', setting) },
			function : (setting) => { callback = setting },
			string   : (setting) => { console.log('string', setting) },
			element  : (setting) => { element = setting	},
			number   : (setting) => { console.log('number', setting) }
		})

		callback(element, this.check(element))

	}

	check() {

		if ( arguments[2] ) {
			delete arguments[2]
		}

    // console.log('Inview Check', arguments.length, arguments)

    let element = false
    let delegate = false
    let offset = 0
    let handlers = {}
    let settings = {}

    this.manage(arguments, {
      string  : (setting) => { element = !element ? document.querySelectorAll(setting) : element },
      number  : (setting) => { offset = setting },
      element : (setting) => {
				// console.log(setting)
        // if ( setting instanceof HTMLDocument ) {
          // console.log(Object.values(arguments).find(e => ))
          // delegate = setting
        // } else {
        element = !(setting instanceof jQuery) ? setting[0] : setting
        // }
      },
      object  : (setting) => {

        if ( 'in' in setting ) {
          handlers['in'] = setting.in
        }

        if ( 'out' in setting ) {
          handlers['out'] = setting.out
        }

				if ( 'delegate' in setting ) {
					if ( setting.delegate === true ) {
						delegate = document.body
					} else {
						delegate = !(setting.delegate instanceof jQuery) ? setting.delegate[0] : setting.delegate
					}
				}

        // } else {
          // this.settings = this.merge(this.defaults, setting, ['headers'])
        // }
      }
    })


		if ( element ) {
      Object.values(element).forEach(item => {
        // if(item.constructor.name == 'HTMLElement') {
        try {
	        if( item instanceof Element && 'getBoundingClientRect' in item ) {
	          let rect = item.getBoundingClientRect()
	          let inview = (rect.height - offset) > 0 && (rect.bottom - offset) >= 0 && (rect.top - offset) <= (window.innerHeight || document.documentElement.clientHeight)
	          if ( inview ) {
	            if ( 'in' in handlers ) {
	              handlers.in(item)
	            }
	          } else {
	            if ( 'out' in handlers ) {
	              handlers.out(item)
	            }
	          }
	        }
				} catch ( error ) {
					console.error(error);
				}
      })
		}
    // return Object.values(result).some(array => array.length) ? result : false
	}

}


//
// class InView {
//
// 	constructor(...args) {
//
// 		if (args.length) {
//
// 			let once = args.find(item => typeof item == 'boolean' && item == true);
//
// 			if (!once) {
// 				return this.visible(...args);
// 			} else {
//
// 				let { element, active, inactive, offset } = this._arguments(...args);
//
// 				this.element  = element;
// 				this.active   = active;
// 				this.inactive = inactive;
// 				this.offset   = offset;
// 				this.once     = true;
// 				this.status   = true;
// 			}
// 		}
// 	}
//
// 	// Visible Actions -----------------------------------------------------------
// 	// Return boolean if element is in viewport. If any functions have been passed,
// 	// trigger the first for the active/visible. Second for inactive/not visible.
//
// 	visible(...args) {
//
// 		let { element, active, inactive, offset } = this._arguments(...args);
//
// 		let once = this.once || false ;
// 		element  = element   || this.element ;
// 		active   = active    || this.active ;
// 		inactive = inactive  || this.inactive ;
// 		offset   = offset    || this.offset ;
//
// 		let isVisible = this.check(element, offset);
//
// 		if ( typeof element !== 'undefined' && active == null && inactive == null) {
// 			return isVisible;
// 		} else {
// 			if (isVisible && (active !== null && typeof active !== 'undefined')) {
// 				if ( !once || once && (this.status == isVisible) ) {
// 					active(element);
// 					this.status = false;
// 				}
// 			} else if (!isVisible && (inactive !== null && typeof inactive !== 'undefined')) {
// 				if ( !once || once && (this.status == isVisible) ) {
// 					inactive(element);
// 					this.status = true;
// 				}
// 			} else {
// 				this.status = true;
// 			}
// 		}
//
// 	}
//
// 	// Return boolean if element is within viewport ------------------------------
//
// 	check(element, offset = 0) {
// 		if ( typeof element !== 'undefined' ) {
// 			var rect = element.getBoundingClientRect();
// 			return (rect.height - offset) > 0 && (rect.bottom - offset) >= 0 && (rect.top - offset) <= (window.innerHeight || document.documentElement.clientHeight);
// 		}
// 	}
//
// 	// Private function to manage all passed arguments ---------------------------
//
// 	_arguments() {
//
// 		let element  = null;
// 		let active   = null;
// 		let inactive = null;
// 		let offset   = 0;
//
// 		Array.prototype.slice.call(arguments).forEach((arg) => {
//
// 			switch (typeof arg) {
// 				case 'function':
// 					if ( active == null ) { active = arg	}
// 					else if ( inactive == null ) { inactive = arg	}
// 				break;
// 				case 'number':
// 					offset = arg;
// 				break;
// 				case 'object':
// 					if ( typeof arg.getBoundingClientRect !== 'undefined' ) {
// 						element = arg;
// 					} else if ( typeof arg[0].getBoundingClientRect !== 'undefined' ) {
// 						element = arg[0];
// 					}
// 				break;
// 			}
//
// 		});
//
// 		return {
// 			'element'  : element,
// 			'active'   : active,
// 			'inactive' : inactive,
// 			'offset'   : offset
// 		};
//
// 	}
//
//
// }
//
// if ( window.jQuery && typeof pluginify !== 'undefined') {
//   pluginify.add('visible', InView);
// }
